<template>
  <div class="full-height background-grey-900">
    <mad-scrollbar>
      <div style="height: 100%">
        <div class="row no-gutter full-height center-xs">
          <div v-if="!isRegister" class="col-md-7 col-xs-fluid-24" style="padding: 32px;">
            <div class="row center-md middle-xs">
              <div class="col-md col-xs-fluid-24">
                <div style="padding: 30px 24px; border-radius: 8px;" class="background-white">
                  <img src="@/assets/petronas.svg" style="width: 40%;margin-bottom: 40px;" alt="" />
                  <div class="font-center margin-bottom-24 font-subhead font-bold">
                    {{ $language.loginLabel }}
                  </div>
                  <form @submit.prevent="submit">
                    <mad-textfield
                      :required="true"
                      v-model="ICPassportNo"
                      :message="$language.messageICPassport"
                      :placeholder="$language.labelICPassport"
                      style="margin-bottom: 32px;"
                    ></mad-textfield>
                    <mad-button :disabled="disabledButton" type="submit" class="primary" style="width: 100%">{{ $language.loginButton }}</mad-button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isRegister" class="col-md-12 col-xs-fluid-24" style="padding: 32px;">
            <div class="row center-xs middle-xs">
              <div class="col-md  col-xs-fluid-24">
                <div style="padding: 30px 24px; border-radius: 8px;" class="background-white">
                  <img src="@/assets/petronas.svg" style="width: 20%;margin-bottom: 40px;" alt="" />
                  <div class="font-center margin-bottom-24 font-subhead font-bold">
                    {{ $language.loginLabel }}
                  </div>
                  <form @submit.prevent="register">
                    <div class="row has-gutter">
                      <div class="col-xs-fluid-24">
                        <mad-textfield
                          :required="true"
                          :disabled="true"
                          v-model="ICPassportNo"
                          :placeholder="$language.labelICPassport"
                        ></mad-textfield>
                      </div>
                      <div class="col-xs-fluid-24">
                        <mad-textfield :required="true" v-model="fullname" :placeholder="$language.fullName"></mad-textfield>
                      </div>
                      <div class="col-xs-fluid-24 col-md-fluid-12">
                        <mad-textfield :required="true" v-model="contactNo" :placeholder="$language.contactNo"></mad-textfield>
                      </div>
                      <div class="col-xs-fluid-24 col-md-fluid-12">
                        <mad-textfield v-model="email" :placeholder="$language.email"></mad-textfield>
                      </div>
                      <div class="col-md-fluid-8" style="margin-bottom: 12px;">
                        <mad-radio :label="$language.petronasStaff" val="1" v-model="userType"></mad-radio>
                      </div>
                      <div class="col-md-fluid-8" style="margin-bottom: 12px;">
                        <mad-radio :label="$language.contractor" val="2" v-model="userType"></mad-radio>
                      </div>
                      <div class="col-md-fluid-8" style="margin-bottom: 12px;">
                        <mad-radio :label="$language.visitor" val="3" v-model="userType"></mad-radio>
                      </div>
                      <div class="col-md-fluid-8" style="margin-bottom: 12px;">
                        <mad-radio :label="$language.tenant" val="4" v-model="userType"></mad-radio>
                      </div>
                      <div class="col-xs-fluid-24 col-md-fluid-12" v-if="userType === '1'">
                        <mad-textfield v-model="staffId" :placeholder="$language.staffId" :required="true"></mad-textfield>
                      </div>
                      <div class="col-xs-fluid-24 col-md-fluid-12" v-if="userType === '4'">
                        <mad-textfield v-model="companyName" :placeholder="$language.tenantName" :required="true"></mad-textfield>
                      </div>
                      <div class="col-xs-fluid-24">
                        <mad-multifield :required="true" v-model="companyAddress" :placeholder="$language.companyAddress"></mad-multifield>
                      </div>
                      <div class="col-xs-fluid-24">
                        <mad-multifield :required="true" v-model="homeAddress" :placeholder="$language.homeAddress"></mad-multifield>
                      </div>
                      <div class="col-xs-fluid-24" style="margin-bottom: 20px;">
                        <mad-button @click="showAttachmentUpload = true" class="primary">{{ $language.uploadDocument }}</mad-button>
                        <div class="font-bold" style="font-size: 12px; margin-top: 10px;">{{ files.length }} {{ $language.numOfAttached }}</div>
                        <div class="font-light" style="font-size: 12px; margin-top: 10px;">
                          {{ $language.supportingDocument }}
                        </div>
                        <AttachmentUpload v-model="showAttachmentUpload" @returnFiles="readFiles" :files="files" />
                      </div>
                    </div>
                    <hr />
                    <div class="font-caption" style="margin-bottom: 20px;">
                      {{ $language.consent }} <a style="cursor: pointer" @click="overlayConsent = true">{{ $language.here }}</a>
                    </div>
                    <div class="row has-gutter">
                      <div class="col-xs-1">
                        <mad-checkbox v-model="IsAgree" :required="true"></mad-checkbox>
                      </div>
                      <div class="col-xs">
                        <div class="font-body" @click="IsAgree = !IsAgree">
                          {{ $language.consentAgree }}
                        </div>
                      </div>
                    </div>
                    <div class="pull-right" style="margin-top: 32px;">
                      <mad-button
                        :disabled="$wait.waiting('record submission')"
                        type="register"
                        button-style="flat"
                        class="primary"
                        @click="isRegister = false"
                        >{{ $language.back }}</mad-button
                      >
                      <mad-button :disabled="$wait.waiting('record submission')" type="register" class="primary">{{ $language.register }}</mad-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mad-scrollbar>
    <mad-overlay v-model="overlayConsent">
      <div class="row center-xs middle-xs;" style="height: 100%;">
        <div class="col-xs-fluid-24 col-md-16" style="height: 100%;">
          <div style="padding: 10px; height: 100%;">
            <mad-card style="height: 100%;">
              <mad-scrollbar style="height: calc(100% - 60px)">
                <div style="padding: 16px;">
                  <div style="margin-bottom: 16px; text-align: center; font-weight: 700;">PETRONAS PRIVACY STATEMENT</div>
                  <p>
                    Petroliam Nasional Berhad (PETRONAS) and its group of companies, (“PETRONAS” or “We”) are committed to protecting and respecting
                    your privacy.
                  </p>
                  <p>
                    This Privacy Statement (“Privacy Statement”) explains what personal data we collect, when and why we collect it, how we use it,
                    the conditions under which we may disclose it to others, and how we keep it secure. Please read it carefully to understand our
                    views and practices regarding your personal data and how we will treat it.
                  </p>
                  <p style="font-weight: 600;">WHO WE ARE</p>
                  <p>
                    PETRONAS is Malaysia’s fully integrated oil and gas multinational with its parent company registered in Malaysia with company
                    number 20076-K. Our address is Tower 1, PETRONAS Twin Towers, Kuala Lumpur City Centre, 50088 Kuala Lumpur, Malaysia.
                  </p>
                  <p style="font-weight: 600;">INFORMATION GATHERING AND USAGE</p>
                  <p>
                    We may collect the following personal data from you in the specified form, such as your name, IC, contact number, address and
                    health declaration when you are entering our premise.
                  </p>
                  <p>
                    We may use personal data that we obtain from you:
                  </p>
                  <ul>
                    <li>
                      to the extent of consent obtained from you, to process, facilitate and administer the personal data for the purpose of pre entry
                      health declaration to monitor the spread of COVID-19 as required by the authorities; and
                    </li>
                    <li>
                      in other circumstances, such purposes that are necessary or directly related to your relationship with us or where it is
                      permitted under the applicable laws.
                    </li>
                  </ul>
                  <p style="font-weight: 600;">Processing your personal data, and obtaining your consent</p>
                  <p>
                    Where we rely on your consent for processing your personal data, you may withdraw your previous consent to this processing at any
                    time, by contacting us by using the contact details below. Please note, however, that withdrawing your consent will not affect the
                    lawfulness of processing based on your previous consent prior to withdrawal.
                  </p>
                  <p>
                    There may be instances where we process your personal data for our legitimate interests or on the basis of other lawful grounds
                    (i.e., because we have established a relationship with you and need to process your personal data in order to provide you with the
                    information and/or services you have requested), without having obtained your consent – this applies where our processing
                    activities are governed by the applicable laws of certain jurisdictions in which we operate that do not require consent to have
                    been obtained where there are legitimate interests and/or other lawful grounds to process the relevant personal data.
                  </p>
                  <p>
                    We do not seek your consent in such cases largely so that we provide you with services in an efficient way (or where in some cases
                    it might not be possible for us to seek your consent because we must process personal data, for example, for the detection of
                    fraud). Before processing your personal data, we will consider your rights and freedoms and will only commence such processing
                    where we do not think your rights will be infringed.
                  </p>
                  <p style="font-weight: 600;">Storage of your information</p>
                  <p>
                    All information you provide to us is stored on our secure servers. We maintain appropriate administrative, technical and physical
                    safeguards to protect against loss, misuse or unauthorized access, disclosure, alteration or destruction of the personal data you
                    provide to us in accordance with applicable laws.
                  </p>
                  <p>
                    Where we have given you (or where you have chosen) a password which enables you to access certain parts of our site, you are
                    responsible for keeping this password confidential. We ask you not to share a password with anyone.
                  </p>
                  <p style="font-weight: 600;">Period for which we store your personal data</p>
                  <p>
                    We only keep your personal data for as long as we require it in order to fulfil the purpose for which it was collected or provided
                    to us (unless a legal obligation requires us to keep it for longer).
                  </p>
                  <p style="font-weight: 600;">Transfers of your information</p>
                  <p>
                    We limit access to personal data we collect about you to our employees and third-party agents (where your consent has been
                    obtained), who we reasonably believe need to have access to your information to provide you with the information or services you
                    request from us. Such third parties may include:
                  </p>
                  <ul>
                    <li>other members of the PETRONAS group of companies;</li>
                    <li>
                      our approved sub-contractors, business partners, suppliers, or other third-party organizations providing administrative, IT or
                      other services to PETRONAS or any member of the PETRONAS group of companies;
                    </li>
                    <li>analytics and search engine providers that assist us in the improvement and optimization of our site; or</li>
                    <li>third parties in connection with the transfer of all or any part of our business or assets.</li>
                  </ul>
                  <p>
                    We will also disclose your personal data to third parties if we are under a duty to disclose or share your personal data in order
                    to comply with any legal obligation, or to protect the rights, property, or safety of the PETRONAS group of companies , our
                    customers, or others.
                  </p>
                  <p>
                    If we transfer your personal data we will always do so under strict conditions of confidentiality and similar levels of security
                    safeguards.
                  </p>
                  <p style="font-weight: 600;">SECURITY</p>
                  <p>
                    We limit access to personal data that we collect about you to our employees and third-party agents, who we reasonably believe need
                    to have access to your information to provide you with the information or services you request from us. We have reasonable
                    security measures in place to help protect against the loss, misuse and alteration of the information under our control. While we
                    cannot guarantee that loss, misuse or alteration to data will not occur, we ensure that our systems adhere to market security
                    standard so as to help safeguard against such occurrences.
                  </p>
                  <p style="font-weight: 600;">CHANGES TO YOUR DETAILS OR PREFERENCES</p>
                  <p>
                    We aim to keep our records as up-to-date and accurate as possible. You can review, change or delete the details supplied to us by
                    contacting us at the contact details set out below. Depending on your location and the nature of our personal data processing
                    activities, the laws of jurisdictions such as the EU might apply to our processing of your personal data. To the extent required
                    by such applicable laws, we may inform you (before collecting your data) if we intend to use your data for such purposes or if we
                    intend to disclose your information to any third party for such purposes.
                  </p>
                  <p>
                    You can exercise your right to prevent such processing by checking certain boxes on the forms we use to collect your data, or by
                    contacting us at the contact details set out below. Please note that if you ask us to delete your data this may impact on our
                    ability to provide the services you request. In addition, we may keep track of certain information for legal compliance purposes,
                    so we may not be able to fully delete it in certain circumstances.
                  </p>
                  <p style="font-weight: 600;">CHANGES TO OUR PRIVACY STATEMENT</p>
                  <p>
                    Any changes we make to our Privacy Statement in the future will be posted on this page. Please check back frequently to see any
                    updates or changes to our Privacy Statement.
                  </p>
                  <p style="font-weight: 600;">LANGUAGE</p>
                  <p>
                    In accordance with the requirement of Malaysian data protection and privacy law, this Privacy Statement is issued in both English
                    and Bahasa Malaysia. In the event of any inconsistencies or discrepancies between the English version and the Bahasa Malaysia
                    version, the English version shall prevail.
                  </p>
                  <p style="font-weight: 600;">HOW YOU CAN CONTACT US</p>
                  <p>Any questions, comments and requests regarding this Privacy Statement are welcomed and should be addressed to:</p>
                  <p>Head Compliance Management, Legal Compliance Department, Group Legal</p>
                  <p>Address : Level 65, Tower 1, PETRONAS Twin Towers, Kuala Lumpur City Centre, 50088 Kuala Lumpur, Malaysia</p>
                  <p>Email Address : legal.compliance@petronas.com.my</p>
                </div>
              </mad-scrollbar>
              <div class="clearfix" style="border-top: 1px solid #eaeaea">
                <div style="padding-top: 12px;" class="pull-right">
                  <mad-button class="primary" @click="overlayConsent = false" :disabled="$wait.waiting('record submission')">
                    Close
                  </mad-button>
                </div>
              </div>
            </mad-card>
          </div>
        </div>
      </div>
    </mad-overlay>
    <mad-overlay v-model="showIEerror">
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100vh; background: #212121">
        <div
          style="position: absolute; top: calc(50% - 100px); left: calc(50% - 250px);
          width: 500px; height: 200px; background: white; padding: 32px; border-radius: 8px;"
        >
          <div class="font-headline font-bold" style="margin-bottom: 20px;">
            Unsupported Browser
          </div>
          <div>
            Internet Explorer is not supported for this application. Please use
            <a href="https://www.google.com/chrome/">Google Chrome</a> or
            <a href="https://www.microsoft.com/en-us/edge/">New Microsoft Edge</a>
            to continue using this application. Thank you
          </div>
        </div>
      </div>
    </mad-overlay>
    <mad-overlay v-model="showPasswordField">
      <div class="row center-xs middle-xs has-gutter" style="height: 100%">
        <div class="col-xs-fluid-24 col-md-6">
          <mad-card>
            <form style="padding: 16px;" @submit.prevent="getTokenAndLogin">
              <div class="font-title font-bold color-grey-800" style="margin-bottom: 16px;text-transform: uppercase;">
                Please enter your password
              </div>
              <mad-textfield :required="true" v-model="password" placeholder="Password" type="password"></mad-textfield>
              <div class="clearfix">
                <div style="padding-top: 12px;" class="pull-right">
                  <mad-button button-style="color" @click="showPasswordField = false" :disabled="disabledButton">
                    {{ $language.close }}
                  </mad-button>
                  <mad-button class="primary" button-style="raised" type="submit" :disabled="disabledButton">
                    <mad-icon name="mdiCheck" size="small"></mad-icon>
                    {{ $language.confirm }}
                  </mad-button>
                </div>
              </div>
            </form>
          </mad-card>
        </div>
      </div>
    </mad-overlay>
    <mad-overlay v-model="isNoLanguage">
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100vh; background: #212121">
        <div
          style="position: absolute; top: calc(50% - 100px); left: calc(50% - 250px);
          width: 500px; height: 230px; background: white; padding: 32px; border-radius: 8px;"
        >
          <div class="font-headline font-bold" style="margin-bottom: 20px;">
            Language Selection
          </div>
          <mad-radio label="English" val="en" v-model="selectedLanguage"></mad-radio>
          <mad-radio label="Bahasa Malaysia" val="my" v-model="selectedLanguage"></mad-radio>
          <div class="pull-right">
            <mad-button :disabled="!selectedLanguage" class="primary" @click="setLanguage">OK</mad-button>
          </div>
        </div>
      </div>
    </mad-overlay>
  </div>
</template>

<script>
import AttachmentUpload from "@/components/AttachmentUpload";
import TOKEN from "@/graphql/token.gql";
import checkIfICPassportIsNotNormalUser from "@/graphql/checkIfICPassportIsNotNormalUser.gql";
import checkICPassportExists from "@/graphql/checkICPassportExists.gql";
import RegisterAndLogin from "@/graphql/registerAndLogin.gql";
import { onLogin } from "@/vue-apollo";
export default {
  data() {
    return {
      email: "",
      password: "",
      ICPassportNo: "",
      isRegister: false,
      checkIfICPassportIsNotNormalUser: false,
      firstname: "",
      lastname: "",
      fullname: "",
      contactNo: "",
      userType: "",
      staffId: "",
      companyAddress: "",
      overlayConsent: false,
      companyName: "",
      homeAddress: "",
      IsAgree: false,
      showIEerror: this.msieversion(),
      language: this.$getLanguage(),
      isNoLanguage: this.language ? false : true,
      selectedLanguage: null,
      showAttachmentUpload: false,
      files: [],
      showPasswordField: false,
      disabledButton: false,
    };
  },
  components: {
    AttachmentUpload,
  },
  mounted() {
    if (localStorage.getItem("COVID-apollo-token")) {
      return this.$router.push("web/");
    }
    this.$nextTick(() => {
      this.checkLanguage();
    });
  },
  methods: {
    msieversion() {
      var isIE = false;
      var ua = window.navigator.userAgent;
      var old_ie = ua.indexOf("MSIE ");
      var new_ie = ua.indexOf("Trident/");

      if (old_ie > -1 || new_ie > -1) {
        isIE = true;
      }

      return isIE;
    },
    setLanguage() {
      this.$setLanguage(this.selectedLanguage);
      this.checkLanguage();
      this.$router.go(0);
    },
    checkLanguage() {
      (this.language = this.$getLanguage()), (this.isNoLanguage = this.language ? false : true);
    },
    async submit() {
      let query1 = this.$apollo.query({
        query: checkICPassportExists,
        variables: {
          ICPassportNo: this.ICPassportNo,
        },
      });

      let query2 = this.$apollo.query({
        query: checkIfICPassportIsNotNormalUser,
        variables: {
          ICPassportNo: this.ICPassportNo,
        },
      });

      let [data1, data2] = await Promise.all([query1, query2]);
      if (!data1.data.checkICPassportExists) {
        return (this.isRegister = true);
      }

      if (data2.data.checkIfICPassportIsNotNormalUser) {
        this.showPasswordField = true;
        return;
      }
      this.getTokenAndLogin();
    },
    getTokenAndLogin() {
      this.disabledButton = true;
      this.$apollo
        .mutate({
          mutation: TOKEN,
          variables: {
            ICPassportNo: this.ICPassportNo,
            Password: this.password,
          },
        })
        .then(data => {
          onLogin(this.$apollo.provider.defaultClient, data.data.token);
          this.showPasswordField = false;
          return this.$router.push("/web/");
        })
        .catch(err => {
          this.password = "";
          this.$popup.run({
            header: "Error",
            message: err.graphQLErrors.map(x => x.message)[0],
            type: "cancel",
          });
          this.showPasswordField = false;
          this.disabledButton = true;
          // console.log(err.message.replace("GraphQL error: ", ""));
        });
    },
    register() {
      if (!this.IsAgree) {
        return this.$popup.run({
          header: "Error",
          message: `Please help to agree with Malaysia’s
          Personal Data Protection Act 2010 and the EU General Data Protection Regulation (GDPR) before continue with registration`,
          type: "cancel",
        });
      }
      this.$wait.start("record submission");
      this.$apollo
        .mutate({
          mutation: RegisterAndLogin,
          variables: {
            ICPassportNo: this.ICPassportNo,
            Email: this.email,
            FullName: this.fullname,
            ContactNo: this.contactNo,
            CompanyAddress: this.companyAddress,
            HomeAddress: this.homeAddress,
            Type: parseInt(this.userType),
            StaffId: this.staffId,
            TenantName: this.companyName,
            AttachmentsId: JSON.stringify(this.files),
          },
        })
        .then(data => {
          onLogin(this.$apollo.provider.defaultClient, data.data.registerAndLogin);
          return this.$router.push("/web/");
        })
        .catch(err => {
          this.password = "";
          this.$popup.run({
            header: "Error",
            message: err.graphQLErrors.map(x => x.message)[0],
            type: "cancel",
          });
          // console.log(err.message.replace("GraphQL error: ", ""));
        })
        .finally(() => {
          this.$wait.end("record submission");
        });
    },
    readFiles(files) {
      this.files = files;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@MadScss/import.scss";
.background-card {
  min-height: 400px;
  padding: 20px;
  background: $theme-primary-gradient-1;
}

.background-side {
  background: #17044c;
}
</style>
